import { Col, Row, Container, Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import clsx from 'clsx';
import { SanityKeyed, Gallery as GalleryProps } from 'types/studio/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import styles from './Gallery.module.scss';
import { StudioBaseImageV2 } from '../StudioBaseImage/StudioBaseImage';
import CustomPortableText from '../PortableText/PortableText';
import { CommonSectionProps } from '../types';

const Gallery = ({
  _key: key,
  headline,
  galleryCards,
  padding,
  theme,
  visibleOnPageLoad
}: SanityKeyed<GalleryProps> & CommonSectionProps) => (
  <Container narrow id={key}>
    <Space
      top={{ xxs: 40, s: 60, m: 80, l: 100 }}
      bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
      className={clsx(getSectionPaddingClasses(styles, padding))}>
      {headline && (
        <Typography
          variant="headlineSans"
          size="2"
          noPadding
          color={getTypographyDefaultColor(theme)}
          className={styles.headline}>
          <CustomPortableText value={headline} />
        </Typography>
      )}
      {galleryCards && (
        <Row className={styles.imagesRow}>
          {galleryCards.map((card) => (
            <Col key={card._key} span={{ xxs: 6, l: 3 }}>
              {card.image?.image && (
                <StudioBaseImageV2
                  image={card.image.image}
                  sizes={{ xxs: '50vw', l: '25vw' }}
                  mobileImage={card.image.mobileImage}
                  tabletImage={card.image.tabletImage}
                  withMobileImage={card.image.withMobileImage}
                  className={styles.image}
                  eagerLoading={visibleOnPageLoad}
                />
              )}
              {card.description && (
                <Typography
                  variant="subtitle"
                  size="1"
                  color={getTypographyDefaultColor(theme)}
                  noPadding
                  className={styles.description}>
                  <CustomPortableText value={card.description} />
                </Typography>
              )}
            </Col>
          ))}
        </Row>
      )}
    </Space>
  </Container>
);

export default Gallery;
